import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/browser'
import { forceSessionLogout } from '../session/session'

export default {
  data: function () {
    return {
      statusCode: {
        400: (error) => {
          this.sendErrorToLogger(error.response.data)
        },
        401: () => {
          forceSessionLogout()
        },
        404: () => {
          this.$router.push({ path: '/404' })
        },
        409: (error) => {
          this.modalError(error.response.data.error, 'warning')
        },
        500: (error) => {
          this.sendErrorToLogger(error.response.data)
          this.modalError('Se ha producido un error interno, ' +
          'por favor intenta nuevamente', 'error')
        }
      }
    }
  },
  methods: {
    checkProtocol: function (url) {
      let protocol = url.split('//')[0]
      const uri = url.split('//')[1]
      if (protocol !== 'https:') {
        protocol = protocol.replace(/^http:/, 'https:')
      }
      return `${protocol}//${uri}`
    },
    httpRequest: function (options) {
      return axios(options)
        .then(res => {
          return res
        })
        .catch(error => {
          this.statusCode[error.response.status](error)
          return error.response
        })
    },
    modalError: function (message, type) {
      Vue.swal({
        type: type,
        title: '',
        text: message,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#00ba68',
        confirmButtonText: 'Cerrar'
      })
    },
    sendErrorToLogger: function (error) {
      Sentry.configureScope(scope => {
        scope.setUser({ email: this.$store.getters.getEmail || 'not logged' })
      })
      Sentry.captureException(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/httpRequestMixin.js